// management-frontend/src/services/apiServicesOpervex.js

import axios from "axios";

class ApiServicesOpervex {
  // Synchronize
  async Synchronize(guid, apiValue) {
    try {
      const apiOpervex = await axios.create({
        baseURL: process.env.REACT_APP_API_OPERVEX,
        headers: {
          "X-API-KEY": apiValue,
          "Content-Type": "application/json",
        },
      });

      const response = await apiOpervex.post(`${guid}/System/Tenant/Synchronize/`);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }

  // Backup
  async Backup(guid, apiValue) {
    try {
      const apiOpervex = await axios.create({
        baseURL: process.env.REACT_APP_API_OPERVEX,
        headers: {
          "X-API-KEY": apiValue,
          "Content-Type": "application/json",
        },
      });

      const response = await apiOpervex.post(
        `${guid}/System/Tenant/Backup/`,
        {},
        {
          responseType: "blob",
        },
      );
      return response;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }

  // Restore
  async Restore(guid, apiValue, file) {
    try {
      const formData = new FormData();

      formData.append("confirmation", "RESTORE");
      formData.append("file", file);

      const apiOpervex = await axios.create({
        baseURL: process.env.REACT_APP_API_OPERVEX,
        headers: {
          "X-API-KEY": apiValue,
        },
      });

      const response = await apiOpervex.post(`${guid}/System/Tenant/Restore/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }

  // Delete
  async Delete(guid, apiValue) {
    try {
      const formData = new FormData();

      formData.append("confirmation", "DELETE");

      const apiOpervex = await axios.create({
        baseURL: process.env.REACT_APP_API_OPERVEX,
        headers: {
          "X-API-KEY": apiValue,
          "Content-Type": "application/json",
        },
      });

      const response = await apiOpervex.post(`${guid}/System/Tenant/Delete/`, formData, {});

      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
}

export default ApiServicesOpervex;
